module.exports = __webpack_public_path__ + "static/img/liucheng.a9f7c4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/liucheng.png
// module id = 2Uc1
// module chunks = 5